import { Icon, Pagination, TextBox } from '@/shared/ui';
import { FC, useState } from 'react';
import { reportQueries, useReportStore } from '@/entities/report';
import { usePersistStore } from '@/shared/lib/store';
import SaveList from './save-list';

interface FrequentlySentenceProps {
    addReview: (sents: string) => void;
    showTextModal: (text: string) => void;
}

export const FrequentlySentence: FC<FrequentlySentenceProps> = ({ addReview, showTextModal }) => {
    const { sUserId } = usePersistStore();
    const { stntReport, setStntReport } = useReportStore();
    const [sents, setSents] = useState<string>('');
    const [page, setPage] = useState(0);

    const { data, isLoading, refetch } = reportQueries.review.getTchDsbdOftensentsList({
        userId: sUserId ?? '',
        page: page,
        size: 5,
        claId: stntReport?.claId,
    });

    const { mutate } = reportQueries.review.postTchDsbdOftensentsSave();

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setSents(e.target.value);
    };

    const onSave = async () => {
        mutate(
            {
                userId: sUserId ?? '',
                sents: sents,
                claId: stntReport?.claId,
            },
            {
                onSuccess: (res) => {
                    if (res?.resultOk) {
                        showTextModal('저장했습니다.');
                        setSents('');
                        refetch();
                    } else showTextModal('저장에 실패했습니다.');
                },
            }
        );
    };

    return (
        <div id="tab_01" className="tab_con">
            <div className="cont-mt save-list">
                <div className="flex-item" style={{ marginTop: '15px' }}>
                    <TextBox
                        type="text"
                        placeholder="자주 쓰는 문구를 저장해 보세요."
                        title="자주 쓰는 문구 입력"
                        style={{ flex: 1 }}
                        value={sents}
                        onChange={changeHandler}
                    />
                    <button className="btn btn-default gray" onClick={onSave}>
                        <Icon icon="add" />
                        추가하기
                    </button>
                </div>
                <SaveList resultList={data} addReview={addReview} />
                <Pagination
                    currentPage={page}
                    totalPages={data?.page.totalPages!}
                    onChange={(page: number) => setPage(page)}
                    pageBtnCount={5}
                />
            </div>
        </div>
    );
};
